import React from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";

const AppLayout = ({ children }) => {
  const location = useLocation();
  
  // Pages that should not have the sidebar layout
  const publicPaths = [
    '/login',
    '/activate', 
    '/owner-setup',
    '/reset-password',
    '/staff/set-password'
  ];
  
  const isPublicPage = publicPaths.includes(location.pathname);
  
  if (isPublicPage) {
    // No sidebar for public pages
    return <>{children}</>;
  }
  
  return (
    <div className="flex flex-col lg:flex-row h-screen overflow-hidden">
      <Sidebar />
      <main className="flex-1 overflow-y-auto bg-background">
        <div className="lg:p-0">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AppLayout;
